<template>
    <o-form :title="$t('sandoz.warehouse_import_job_details')" class="ortic-form-horizontal" ref="form"
            :url="'/api/sandoz/warehouse_import_jobs/' + $route.params.id +'?include=details'" :enable-save="false">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-form-group :label="$t('core.date')" class="mb-0">
                        <div class="form-control border-0">
                            {{ props.item.created_at | formatDatetime }}
                        </div>
                    </o-form-group>
                    <o-form-group :label="$t('sandoz.status')" class="mb-0">
                        <div class="form-control border-0">
                            <b-badge :variant="statusVariant(props.item.status)">
                                {{ props.item.status ? $t('sandoz.' + props.item.status): "" }}
                            </b-badge>
                        </div>
                    </o-form-group>
                    <o-form-group :label="$t('sandoz.duration')" class="mb-0">
                        <div class="form-control border-0">
                            {{ formatDuration(props.item.duration_seconds) }}
                        </div>
                    </o-form-group>
                </b-col>
                <b-col></b-col>
            </b-row>
        </template>
        <template slot="child" slot-scope="props">
            <b-table v-if="props.item.details && props.item.details.length"
                     :items="props.item.details"
                     :fields="detailFields"
                     class="mt-3" striped hover responsive>
                <template #cell(entity_name)="data">
                    {{ data.value }}
                </template>
                <template #cell(status)="data">
                    <b-badge :variant="statusVariant(data.value)">
                        {{ data.value ? $t('sandoz.' + data.value) : '' }}
                    </b-badge>
                </template>
                <template #cell(records_imported)="data">
                    {{ data.value !== null ? data.value : '-' }}
                </template>
                <template #cell(records_deleted)="data">
                    {{ data.value !== null ? data.value : '-' }}
                </template>
                <template #cell(error_message)="data">
                    <span v-if="data.value" class="text-danger">{{ data.value }}</span>
                    <span v-else>-</span>
                </template>
            </b-table>
        </template>
    </o-form>
</template>

<script>
  export default {
      data() {
          return {
              stateList: []
          }
      },
      computed: {
          detailFields() {
              return [
                  { key: 'entity_name', label: this.$t('sandoz.entity'), sortable: true },
                  { key: 'status', label: this.$t('sandoz.status'), sortable: true },
                  { key: 'records_imported', label: this.$t('sandoz.records_imported'), sortable: true },
                  { key: 'records_deleted', label: this.$t('sandoz.records_deleted'), sortable: true },
                  { key: 'error_message', label: this.$t('sandoz.error_message'), sortable: false }
              ]
          }
      },
      created() {
          this.stateList = [
              {value: 'running', text: this.$i18n.t('sandoz.running')},
              {value: 'failed', text: this.$i18n.t('sandoz.failed')},
              {value: 'successful', text: this.$i18n.t('sandoz.successful')},
          ]
      },
      methods: {
          formatDuration(seconds) {
              if (seconds === null || seconds === undefined) return '-'
              if (seconds < 60) return seconds + 's'
              const minutes = Math.floor(seconds / 60)
              const remainingSeconds = seconds % 60
              return minutes + 'm ' + remainingSeconds + 's'
          },
          statusVariant(status) {
              switch (status) {
                  case 'successful': return 'success'
                  case 'failed': return 'danger'
                  case 'running': return 'warning'
                  default: return 'secondary'
              }
          }
      }
  }
</script>
